import { render, staticRenderFns } from "./InvoiceReminderList.vue?vue&type=template&id=29c01334&scoped=true&"
import script from "./InvoiceReminderList.vue?vue&type=script&lang=js&"
export * from "./InvoiceReminderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c01334",
  null
  
)

export default component.exports